import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import { useCuration } from '@hooks/useCuration';

import Clients from '@views/Clients/Main';

export default function ClientsPage() {
  const { reset } = useCuration();

  useEffect(() => {
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RoleGuard roles={[RoleName.Admin, RoleName.Curator]}>
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        <Clients />
      </ErrorBoundary>
    </RoleGuard>
  );
}
